import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_GammisAuthReqAmerigroup = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_GammisAuthReqAmerigroup' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>AUTHORIZATION REQUEST FOR AMERIGROUP</h3></center></p>

                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Member Name:</span></td>
                        <td className='w-250'><span className='eleHeader'>Member ID:</span></td>
                        <td className='w-250'><span className='eleHeader'>DOB</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMemberName' name='txtMemberName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtMemberId' name='txtMemberId' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtMemberDob' name='txtMemberDob' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>AUTHORIZATION REQUEST FOR AMERIGROUP</h4></p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Does the member have a PCP?</span></td>
                        <td className='w-375'><span className='eleHeader'>Is Case being coordinated with PCP?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbMemberHavePcp_Yes' name='rbMemberHavePcp' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMemberHavePcp_No' name='rbMemberHavePcp' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbMemberHavePcp_Unknown' name='rbMemberHavePcp' className='add-only' value='Unknown' /> Unknown
                        </td>

                        <td className='w-375'>
                            <input type='radio' id='rbCoordinatedWithPcp_Yes' name='rbCoordinatedWithPcp' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCoordinatedWithPcp_No' name='rbCoordinatedWithPcp' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Diag. Code:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <b>Primary : </b>
                            <input type='text' id='txtDiagCodePrimary' name='txtDiagCodePrimary' className='add-only w-250 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <b>Secondary : </b>
                            <input type='text' id='txtDiagCodeSecondary' name='txtDiagCodeSecondary' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Requested Services:</h4></p>

                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>CPT Code <br />&nbsp;</span></td>
                        <td className='w-150'><span className='eleHeader'>CPT Description <br />&nbsp;</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Staff providing Service</span>
                            <span className='small'>(must include names)</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Current frequency of service</span></td>
                        <td className='w-150'><span className='eleHeader'>Last date seen for service: </span></td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>90832/90834/90837</td>
                        <td className='w-150'>Individual Counseling</td>
                        <td className='w-150'><input type='text' id='txtStaffProviding_1' name='txtStaffProviding_1' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtCurrentFrequency_1' name='txtCurrentFrequency_1' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtLastDate_1' name='txtLastDate_1' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>H0004/90846/90847</td>
                        <td className='w-150'>Family Counseling - With and without client</td>
                        <td className='w-150'><input type='text' id='txtStaffProviding_2' name='txtStaffProviding_2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtCurrentFrequency_2' name='txtCurrentFrequency_2' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtLastDate_2' name='txtLastDate_2' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>H2017 - Adult</td>
                        <td className='w-150'>Psychosocial Rehabilitation</td>
                        <td className='w-150'><input type='text' id='txtStaffProviding_3' name='txtStaffProviding_3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtCurrentFrequency_3' name='txtCurrentFrequency_3' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtLastDate_3' name='txtLastDate_3' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>T1016 - Adult</td>
                        <td className='w-150'>Case Management</td>
                        <td className='w-150'><input type='text' id='txtStaffProviding_4' name='txtStaffProviding_4' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtCurrentFrequency_4' name='txtCurrentFrequency_4' className='add-only' /></td>
                        <td className='w-150'>
                        Last day seen for CSM: &nbsp;<input type='date' id='txtLastDate_41' name='txtLastDate_41' className='add-only' /> <br />
                        Last day seen for collateral CSM: &nbsp;<input type='date' id='txtLastDate_42' name='txtLastDate_42' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>Substance Abuse - Adult</td>
                        <td className='w-150'>Non-Intensive Outpatient Treatment</td>
                        <td className='w-150'><input type='text' id='txtStaffProviding_5' name='txtStaffProviding_5' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtCurrentFrequency_5' name='txtCurrentFrequency_5' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtLastDate_5' name='txtLastDate_5' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>H2015 - Children</td>
                        <td className='w-150'>Community Support Individual</td>
                        <td className='w-150'><input type='text' id='txtStaffProviding_6' name='txtStaffProviding_6' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtCurrentFrequency_6' name='txtCurrentFrequency_6' className='add-only' /></td>
                        <td className='w-150'>
                            Last day seen for CSM: &nbsp;<input type='date' id='txtLastDate_61' name='txtLastDate_61' className='add-only' /> <br />
                            Last day seen for collateral CSM: &nbsp;<input type='date' id='txtLastDate_62' name='txtLastDate_62' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>H2014 - Children</td>
                        <td className='w-150'>Family Skills Training</td>
                        <td className='w-150'><input type='text' id='txtStaffProviding_7' name='txtStaffProviding_7' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtCurrentFrequency_7' name='txtCurrentFrequency_7' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtLastDate_7' name='txtLastDate_7' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>Other
                            <span className='small'>(Please specify in next section)</span>
                        </td>
                        <td className='w-150'><input type='text' id='txtStaffProviding_8' name='txtStaffProviding_8' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtCurrentFrequency_8' name='txtCurrentFrequency_8' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txt' name='txt' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtLastDate_8' name='txtLastDate_8' className='add-only' />
                        </td>
                    </tr>

                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comments/Message</span>
                    <span className='small'>(Therapeutic Approach/Modalities)</span>
                    <textarea name='txtCommentsMessage' id='txtCommentsMessage' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>Current Clinical Information:</h4></p>

                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Symptoms/Problems</span></td>
                        <td className='w-150'><span className='eleHeader'>Severity</span></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><b>Anxiety Disorders</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbAnxietyDisorders_ObsessionsCompulsions' id='cbAnxietyDisorders_ObsessionsCompulsions' className='add-only' value='ObsessionsCompulsions' /> Obsessions/Compulsions
                        </td>
                        <td className='w-150'>
                            <select id='ddlAnxietyDisorders_ObsessionsCompulsions' name='ddlAnxietyDisorders_ObsessionsCompulsions' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbAnxietyDisorders_GeneralizedAnxiety' id='cbAnxietyDisorders_GeneralizedAnxiety' className='add-only' value='GeneralizedAnxiety' /> Generalized Anxiety
                        </td>
                        <td className='w-150'>
                            <select id='ddlAnxietyDisorders_GeneralizedAnxiety' name='ddlAnxietyDisorders_GeneralizedAnxiety' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbAnxietyDisorders_PanicAttacks' id='cbAnxietyDisorders_PanicAttacks' className='add-only' value='PanicAttacks' /> Panic Attacks
                        </td>
                        <td className='w-150'>
                            <select id='ddlAnxietyDisorders_PanicAttacks' name='ddlAnxietyDisorders_PanicAttacks' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbAnxietyDisorders_Phobias' id='cbAnxietyDisorders_Phobias' className='add-only' value='Phobias' /> Phobias
                        </td>
                        <td className='w-150'>
                            <select id='ddlAnxietyDisorders_Phobias' name='ddlAnxietyDisorders_Phobias' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbAnxietyDisorders_SomaticComplaints' id='cbAnxietyDisorders_SomaticComplaints' className='add-only' value='SomaticComplaints' /> Somatic Complaints
                        </td>
                        <td className='w-150'>
                            <select id='ddlAnxietyDisorders_SomaticComplaints' name='ddlAnxietyDisorders_SomaticComplaints' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbAnxietyDisorders_PtsdSymptoms' id='cbAnxietyDisorders_PtsdSymptoms' className='add-only' value='PtsdSymptoms' /> PTSD Symptoms
                        </td>
                        <td className='w-150'>
                            <select id='ddlAnxietyDisorders_PtsdSymptoms' name='ddlAnxietyDisorders_PtsdSymptoms' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Symptoms/Problems</span></td>
                        <td className='w-150'><span className='eleHeader'>Severity</span></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><b>Depression</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbDepression_ImpairedConcentration' id='cbDepression_ImpairedConcentration' className='add-only' value='ImpairedConcentration' /> Impaired concentration
                        </td>
                        <td className='w-150'>
                            <select id='ddlDepression_ImpairedConcentration' name='ddlDepression_ImpairedConcentration' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbDepression_ImpairedMemory' id='cbDepression_ImpairedMemory' className='add-only' value='ImpairedMemory' /> Impaired memory
                        </td>
                        <td className='w-150'>
                            <select id='ddlDepression_ImpairedMemory' name='ddlDepression_ImpairedMemory' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbDepression_PsychomotorRetardation' id='cbDepression_PsychomotorRetardation' className='add-only' value='PsychomotorRetardation' /> Psychomotor retardation
                        </td>
                        <td className='w-150'>
                            <select id='ddlDepression_PsychomotorRetardation' name='ddlDepression_PsychomotorRetardation' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbDepression_SexualIssues' id='cbDepression_SexualIssues' className='add-only' value='SexualIssues' /> Sexual Issues
                        </td>
                        <td className='w-150'>
                            <select id='ddlDepression_SexualIssues' name='ddlDepression_SexualIssues' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbDepression_AppetiteDisturbance' id='cbDepression_AppetiteDisturbance' className='add-only' value='AppetiteDisturbance' /> Appetite Disturbance
                        </td>
                        <td className='w-150'>
                            <select id='ddlDepression_AppetiteDisturbance' name='ddlDepression_AppetiteDisturbance' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbDepression_Irritability' id='cbDepression_Irritability' className='add-only' value='Irritability' /> Irritability
                        </td>
                        <td className='w-150'>
                            <select id='ddlDepression_Irritability' name='ddlDepression_Irritability' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbDepression_SleepDisturbance' id='cbDepression_SleepDisturbance' className='add-only' value='SleepDisturbance' /> Sleep Disturbance
                        </td>
                        <td className='w-150'>
                            <select id='ddlDepression_SleepDisturbance' name='ddlDepression_SleepDisturbance' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbDepression_HopelessnessHelplessness' id='cbDepression_HopelessnessHelplessness' className='add-only' value='HopelessnessHelplessness' /> Hopelessness/Helplessness
                        </td>
                        <td className='w-150'>
                            <select id='ddlDepression_HopelessnessHelplessness' name='ddlDepression_HopelessnessHelplessness' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Symptoms/Problems</span></td>
                        <td className='w-150'><span className='eleHeader'>Severity</span></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><b>Mania</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbMania_Insomnia' id='cbMania_Insomnia' className='add-only' value='Insomnia' /> Insomnia
                        </td>
                        <td className='w-150'>
                            <select id='ddlMania_Insomnia' name='ddlMania_Insomnia' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbMania_Grandiosity' id='cbMania_Grandiosity' className='add-only' value='Grandiosity' /> Grandiosity
                        </td>
                        <td className='w-150'>
                            <select id='ddlMania_Grandiosity' name='ddlMania_Grandiosity' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbMania_PressuredSpeech' id='cbMania_PressuredSpeech' className='add-only' value='PressuredSpeech' /> Pressured Speech
                        </td>
                        <td className='w-150'>
                            <select id='ddlMania_PressuredSpeech' name='ddlMania_PressuredSpeech' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbMania_RacingThoughts' id='cbMania_RacingThoughts' className='add-only' value='RacingThoughts' /> Racing thoughts/flight of ideas
                        </td>
                        <td className='w-150'>
                            <select id='ddlMania_RacingThoughts' name='ddlMania_RacingThoughts' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbMania_PoorJudgement' id='cbMania_PoorJudgement' className='add-only' value='PoorJudgement' /> Poor Judgement/impulsiveness
                        </td>
                        <td className='w-150'>
                            <select id='ddlMania_PoorJudgement' name='ddlMania_PoorJudgement' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Symptoms/Problems</span></td>
                        <td className='w-150'><span className='eleHeader'>Severity</span></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><b>Psychotic Disorder</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbPsychoticDisorder_DelusionsParanoia' id='cbPsychoticDisorder_DelusionsParanoia' className='add-only' value='DelusionsParanoia' /> Delusions/Paranoia
                        </td>
                        <td className='w-150'>
                            <select id='ddlPsychoticDisorder_DelusionsParanoia' name='ddlPsychoticDisorder_DelusionsParanoia' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbPsychoticDisorder_SelfCareIssues' id='cbPsychoticDisorder_SelfCareIssues' className='add-only' value='SelfCareIssues' /> Self-Care Issues
                        </td>
                        <td className='w-150'>
                            <select id='ddlPsychoticDisorder_SelfCareIssues' name='ddlPsychoticDisorder_SelfCareIssues' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbPsychoticDisorder_Hallucinations' id='cbPsychoticDisorder_Hallucinations' className='add-only' value='Hallucinations' /> Hallucinations
                        </td>
                        <td className='w-150'>
                            <select id='ddlPsychoticDisorder_Hallucinations' name='ddlPsychoticDisorder_Hallucinations' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbPsychoticDisorder_DisorganizedThought' id='cbPsychoticDisorder_DisorganizedThought' className='add-only' value='DisorganizedThought' /> Disorganized thought process
                        </td>
                        <td className='w-150'>
                            <select id='ddlPsychoticDisorder_DisorganizedThought' name='ddlPsychoticDisorder_DisorganizedThought' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbPsychoticDisorder_LooseAssociations' id='cbPsychoticDisorder_LooseAssociations' className='add-only' value='LooseAssociations' /> Loose associations
                        </td>
                        <td className='w-150'>
                            <select id='ddlPsychoticDisorder_LooseAssociations' name='ddlPsychoticDisorder_LooseAssociations' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Symptoms/Problems</span></td>
                        <td className='w-150'><span className='eleHeader'>Severity</span></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><b>Substance Abuse</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbSubstanceAbuse_LossControlDosage' id='cbSubstanceAbuse_LossControlDosage' className='add-only' value='LossControlDosage' /> Loss of control of dosage
                        </td>
                        <td className='w-150'>
                            <select id='ddlSubstanceAbuse_LossControlDosage' name='ddlSubstanceAbuse_LossControlDosage' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbSubstanceAbuse_AmnesticEpisodes' id='cbSubstanceAbuse_AmnesticEpisodes' className='add-only' value='AmnesticEpisodes' /> Amnestic Episodes
                        </td>
                        <td className='w-150'>
                            <select id='ddlSubstanceAbuse_AmnesticEpisodes' name='ddlSubstanceAbuse_AmnesticEpisodes' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbSubstanceAbuse_LegalProblems' id='cbSubstanceAbuse_LegalProblems' className='add-only' value='LegalProblems' /> Legal Problems
                        </td>
                        <td className='w-150'>
                            <select id='ddlSubstanceAbuse_LegalProblems' name='ddlSubstanceAbuse_LegalProblems' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbSubstanceAbuse_AlcoholAbuse' id='cbSubstanceAbuse_AlcoholAbuse' className='add-only' value='AlcoholAbuse' /> Alcohol Abuse
                        </td>
                        <td className='w-150'>
                            <select id='ddlSubstanceAbuse_AlcoholAbuse' name='ddlSubstanceAbuse_AlcoholAbuse' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbSubstanceAbuse_OpiateAbuse' id='cbSubstanceAbuse_OpiateAbuse' className='add-only' value='OpiateAbuse' /> Opiate Abuse
                        </td>
                        <td className='w-150'>
                            <select id='ddlSubstanceAbuse_OpiateAbuse' name='ddlSubstanceAbuse_OpiateAbuse' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbSubstanceAbuse_PrescriptionMedicationAbuse' id='cbSubstanceAbuse_PrescriptionMedicationAbuse' className='add-only' value='PrescriptionMedicationAbuse' /> Prescription Medication Abuse
                        </td>
                        <td className='w-150'>
                            <select id='ddlSubstanceAbuse_PrescriptionMedicationAbuse' name='ddlSubstanceAbuse_PrescriptionMedicationAbuse' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbSubstanceAbuse_PolysubstanceAbuse' id='cbSubstanceAbuse_PolysubstanceAbuse' className='add-only' value='PolysubstanceAbuse' /> Polysubstance Abuse
                        </td>
                        <td className='w-150'>
                            <select id='ddlSubstanceAbuse_PolysubstanceAbuse' name='ddlSubstanceAbuse_PolysubstanceAbuse' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Symptoms/Problems</span></td>
                        <td className='w-150'><span className='eleHeader'>Severity</span></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><b>Personality Disorder</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbPersonalityDisorder_OddnessEccentricities' id='cbPersonalityDisorder_OddnessEccentricities' className='add-only' value='OddnessEccentricities' /> Oddness/Eccentricities
                        </td>
                        <td className='w-150'>
                            <select id='ddlPersonalityDisorder_OddnessEccentricities' name='ddlPersonalityDisorder_OddnessEccentricities' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbPersonalityDisorder_Oppositional' id='cbPersonalityDisorder_Oppositional' className='add-only' value='Oppositional' /> Oppositional
                        </td>
                        <td className='w-150'>
                            <select id='ddlPersonalityDisorder_Oppositional' name='ddlPersonalityDisorder_Oppositional' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbPersonalityDisorder_DisregardLaw' id='cbPersonalityDisorder_DisregardLaw' className='add-only' value='DisregardLaw' /> Disregard for law
                        </td>
                        <td className='w-150'>
                            <select id='ddlPersonalityDisorder_DisregardLaw' name='ddlPersonalityDisorder_DisregardLaw' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbPersonalityDisorder_RecurringSelfInjuries' id='cbPersonalityDisorder_RecurringSelfInjuries' className='add-only' value='RecurringSelfInjuries' /> Recurring self-injuries
                        </td>
                        <td className='w-150'>
                            <select id='ddlPersonalityDisorder_RecurringSelfInjuries' name='ddlPersonalityDisorder_RecurringSelfInjuries' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbPersonalityDisorder_SenseEntitlement' id='cbPersonalityDisorder_SenseEntitlement' className='add-only' value='SenseEntitlement' /> Sense of entitlement
                        </td>
                        <td className='w-150'>
                            <select id='ddlPersonalityDisorder_SenseEntitlement' name='ddlPersonalityDisorder_SenseEntitlement' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbPersonalityDisorder_PassiveAggressive' id='cbPersonalityDisorder_PassiveAggressive' className='add-only' value='PassiveAggressive' /> Passive Aggressive
                        </td>
                        <td className='w-150'>
                            <select id='ddlPersonalityDisorder_PassiveAggressive' name='ddlPersonalityDisorder_PassiveAggressive' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbPersonalityDisorder_Dependency' id='cbPersonalityDisorder_Dependency' className='add-only' value='Dependency' /> Dependency
                        </td>
                        <td className='w-150'>
                            <select id='ddlPersonalityDisorder_Dependency' name='ddlPersonalityDisorder_Dependency' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <input type='checkbox' name='cbPersonalityDisorder_EnduringTraits' id='cbPersonalityDisorder_EnduringTraits' className='add-only' value='EnduringTraits' /> Enduring Traits of: &nbsp;
                            <input type='text' name='txtPersonalityDisorder_EnduringTraits' id='txtPersonalityDisorder_EnduringTraits' className='add-only w-250 custom-add-only' />
                        </td>
                        <td className='w-150'>
                            <select id='ddlPersonalityDisorder_EnduringTraits' name='ddlPersonalityDisorder_EnduringTraits' className='add-only'>
                                <option value='Na'></option>
                                <option value='Mild'> Mild</option>
                                <option value='Moderate'> Moderate</option>
                                <option value='Severe'> Severe</option>
                                <option value='Acute'> Acute</option>
                                <option value='Chronic'> Chronic</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Risk of Harm</span>
                    <textarea name='txtRiskHarm' id='txtRiskHarm' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Functional Status</span>
                    <textarea name='txtFunctionalStatus' id='txtFunctionalStatus' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Co-morbidities</span>
                    <textarea name='txtComorbidities' id='txtComorbidities' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Environmental Stressors</span>
                    <textarea name='txtEnvironmentalStressors' id='txtEnvironmentalStressors' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Support in the environment</span>
                    <textarea name='txtSupportEnvironment' id='txtSupportEnvironment' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Response to current treatment plan</span>
                    <textarea name='txtResponseCurrentTreatmentPlan' id='txtResponseCurrentTreatmentPlan' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Acceptance of Engagement</span>
                    <textarea name='txtAcceptanceEngagement' id='txtAcceptanceEngagement' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Transportation available</span>
                    <textarea name='txtTransportationAvailable' id='txtTransportationAvailable' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>History:</span>
                    <textarea name='txtHistory' id='txtHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Presenting Problem</span>
                    <textarea name='txtPresentingProblem' id='txtPresentingProblem' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Medications</span>
                    <textarea name='txtMedications' id='txtMedications' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Next Steps/Other Clinical Information</span>
                    <textarea name='txtNextSteps' id='txtNextSteps' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-360'></td>
                        <td className='signature w-360'></td>
                    </tr>
                    <tr>
                        <td className='small w-360'> Signature: </td>
                        <td className='small w-360'> Date: </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}   